export default async ({ block }) => {
  const reqTabs = block.querySelectorAll('.requirements .tab-menu .tab-row');

  function clickHandler(tabEl) {
    const tabIdx = tabEl.getAttribute('data-tab-index');
    const reqIdx = tabEl.getAttribute('data-req-index');

    if (tabIdx && reqIdx) {
      const reqMenuTabs = block.querySelector(`#tab-menu-${reqIdx}`).childNodes;
      reqMenuTabs.forEach(el => {
        el.classList.remove('tab-menu-current');
      });
      block.querySelector(`[id='${tabIdx}']`).classList.add('tab-menu-current');

      const reqContentTabs = block.querySelector(`#requirements-system-list-${reqIdx}`).childNodes;
      reqContentTabs.forEach(el => {
        el.classList.remove('tab-content--active');
      });
      block.querySelector(`#tab-content-${tabIdx}`).classList.add('tab-content--active');
    }
  }

  reqTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      clickHandler(tab);
    });
  });
};
